const COLOR_MIX = 'color: color-mix(in oklab, red 50%, blue)';

const PROBES = {
  arrayAt: () => typeof [].at === 'function',
  arrayToSorted: () => typeof [].toSorted === 'function',
  objectHasOwn: () => typeof Object.hasOwn === 'function',
  cssColorMix: () => CSS.supports(COLOR_MIX),
};

export type Feature = keyof typeof PROBES;

const FEATURES = Object.keys(PROBES) as Feature[];

export function unsupportedFeatures(): Feature[] {
  return FEATURES.filter((feature) => {
    try {
      return !PROBES[feature]();
    } catch {
      return true;
    }
  });
}
